var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-sub-title',{attrs:{"text":`Gestión documental`}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('app-file-management-filters',{on:{"filter":_vm.onFilter}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('app-file-management-list',{attrs:{"data":_vm.data},on:{"change-page":_vm.changePage,"sort":_vm.onSort}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }